import { render, staticRenderFns } from "./FamiliasVisitadas.vue?vue&type=template&id=2dbc2fd5"
import script from "./FamiliasVisitadas.vue?vue&type=script&lang=js"
export * from "./FamiliasVisitadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports